import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import { toast } from "react-toastify";
import api from "../../services/instance";

export const forgotPasswordAPI = createAsyncThunk(
    'forgotPasswordAPI',
    async (data) => {
        try {
            const response = await api.post(endpoints.forgotPassword(), data);
            if (response.status === 200) {
                toast.success(response.data.message);
            } else {
                toast.error("Something went wrong. Please try again.");
            }
            return response;
        } catch (error) {
            console.error("Forgot Password API Error:", error);
            if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("An unexpected error occurred. Please try again later.");
            }
            throw error;
        }
    }
)

const initialState = {
    loading: false,
}

export const forgotPasswordSlice = createSlice({
    initialState,
    name: "forgotPasswordState",
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(forgotPasswordAPI.pending, (state, action) => {
            state.loading = true;
        });

        builder.addCase(forgotPasswordAPI.fulfilled, (state, action) => {
            state.loading = false;
        })

        builder.addCase(forgotPasswordAPI.rejected, (state, action) => {
            state.loading = false;
        })
    }
})

export const { } = forgotPasswordSlice.actions
export default forgotPasswordSlice.reducer